import React, { Component, Fragment } from 'react'
import ReactDOM from 'react-dom'
import Svg from './Svg'
import { css } from 'react-emotion'
import { ModalOverlay, ModalDialog } from '../../styles'

const CloseButton = css`
  position: absolute;
  top: 10px;
  right: 10px;
  color: #fff;
  height: 40px !important;
  width: 40px !important;
  cursor: pointer;
  z-index: 30002;
  @media (max-width: 767px) {
    top: 5px;
    right: 5px;
    height: 1.5em !important;
    width: 1.5em !important;
  }
`

const portalRoot = document.getElementById('customer-mytui-web-portal-root')

export default class Modal extends Component {
  state = { open: false }
  componentDidMount() {
    this.modal = document.createElement('div')
    if (this.props.open)
      this.open()
  }
  componentWillUnmount() {
    if (this.props.open)
      this.close()
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.open)
      this.open()
  }
  open = () => {
    portalRoot.appendChild(this.modal)
    document.body.classList.add('x-tui-modal')
    this.setState({ open: true })
  }
  close = () => {
    if (portalRoot.contains(this.modal))
      portalRoot.removeChild(this.modal)
    document.body.classList.remove('x-tui-modal')
    this.setState({ open: false })
    this.props.onClose && this.props.onClose()
  }
  render() {
    const { children, Opener, easyClose = true } = this.props
    const { open } = this.state

    const portal = open && ReactDOM.createPortal(
      <ModalOverlay onClick={easyClose ? this.close : () => { }}>
        <Svg className={CloseButton} onClick={easyClose ? () => { } : this.close} icon="times" />
        <ModalDialog onClick={e => e.stopPropagation()} {...this.props} >
          {children}
        </ModalDialog>
      </ModalOverlay>,
      this.modal
    )

    if (!Opener)
      return portal

    return (
      <Fragment>
        {portal}
        <span onClick={this.open}>
          <Opener />
        </span>
      </Fragment>
    )
  }
}